export enum AssistantActionTypes {
    PostQuestion = "ASSISTANT_POST_QUESTION",
    PostQuestionPending = "ASSISTANT_POST_QUESTION_PENDING",
    PostQuestionRejected = "ASSISTANT_POST_QUESTION_REJECTED",
    PostQuestionFulFilled = "ASSISTANT_POST_QUESTION_FULFILLED",
    SetActiveSubjectDate = "ASSISTANT_SET_ACTIVE_SUBJECT_DATE",
    SetActiveSubjects = "ASSISTANT_SET_ACTIVE_SUBJECTS"
};

export default AssistantActionTypes;